import { __extends } from "tslib";

var MissingLocaleDataError =
/** @class */
function (_super) {
  __extends(MissingLocaleDataError, _super);

  function MissingLocaleDataError() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.type = 'MISSING_LOCALE_DATA';
    return _this;
  }

  return MissingLocaleDataError;
}(Error);

export function isMissingLocaleDataError(e) {
  return e.type === 'MISSING_LOCALE_DATA';
}